import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as globals from '@reusable/services/globals';
import { ToastrService } from 'ngx-toastr';
import { EMPTY } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable()
export class UsersService {
  handleError: any;
  jwtHelper = new JwtHelperService();
  responseData: any;
  options;

  constructor(private httpClient: HttpClient, private gtn: globals.GetTokenNow, private toastr: ToastrService) {
    this.httpClient = httpClient;

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    if (localStorage?.getItem('accessToken')) {
      headers = headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`);
    }
    this.options = { headers };
  }

  userDecodeJWT() {
    if (!localStorage.getItem('accessToken')) {
      return false;
    }
    const token = this.jwtHelper.decodeToken(localStorage.getItem('accessToken'));
    return token;
  }

  sendCode(body) {
    return this.httpClient.post(`${globals.domain}/customer/login/sendCode`, body).pipe(map(res => res as any));
  }

  logOut(body) {
    return this.httpClient.put(`${globals.domain}/logout`, body).pipe(map(res => res as any));
  }

  viewProfile() {
    return this.httpClient.get(`${globals.domain}/customer/profile/view`, this.gtn.getHeaders()).pipe(map(res => res as any));
  }

  UpdateProfile(body) {
    return this.httpClient.put(`${globals.domain}/customer/profile/update/`, JSON.stringify(body), this.gtn.getHeaders())
      .pipe(map((res:any) => {
        if ((res as any).case === 2) {
          this.toastr.warning('هذا الإيميل موجود من قبل مستخدم اخر، أدخل إيميل أخر.');
          return EMPTY;
        }
        return res as any;
      }));
  }

  registerProvider(formData) {
    return this.httpClient.post(`${globals.domain}/provider/register/`, JSON.stringify(formData), this.gtn.getHeaders()).pipe(map(res => res as any));
  }
}